import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'cnpj',
})
export class CnpjPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value

    value = value.replace(/\D/g, '') // Remove tudo o que não for número
    if (value.length <= 2) return value
    if (value.length <= 5) return value.replace(/(\d{2})(\d{0,3})/, '$1.$2')
    if (value.length <= 8)
      return value.replace(/(\d{2})(\d{3})(\d{0,3})/, '$1.$2.$3')
    if (value.length <= 12)
      return value.replace(/(\d{2})(\d{3})(\d{3})(\d{0,4})/, '$1.$2.$3/$4')
    return value.replace(
      /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
      '$1.$2.$3/$4-$5',
    )
  }
}
